import { ADD_REPLACEMENT_VALUE, BANKING_DETAILS, DASHBOARD, GET_BUILDING_QUOTATION, GET_HOME_CONTENT_QUOTATION } from '../routes/routes';
import {
    MODAL_SALES_HIDE, MODAL_SALES_SHOW
} from './../constants/constants';
import { navigateTo } from './navigationActions';
import { setIsOnQuoteScreen, switchToBuilding, switchToHomeContent } from './salesActions';

export const hideModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SALES_HIDE,
        });
    }
}

export const showModalRegisteredInSouthAfrica = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">Unfortunately, we don't offer car warranty insurance for cars that aren't registered in SA.
                    <br /><br />
                    For more info, you can give us a call on
                    <br/>
                    <b class="red">0860 50 50 50</b> </p>`;

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {},
                cancelButtonText: 'Exit quote',
            }
        });
    }
}

export const showModalCalculatorBroke = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">It looks like the king's calculator broke. To complete your quote, you can request a call back or call us on 
                    <br />
                    <b>0860 50 50 50</b> </p>`;
        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Call me back',
                okButtonEvent: () => {
                    dispatch(hideModal());
                    dispatch(navigateTo(DASHBOARD));
                },
                cancelButtonText: 'Cancel',
                showClose: false,
            }
        });
    }
}

export const showModalPerformanceMods = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">Unfortunately, we don't offer car warranty insurance for cars that have been modified.
                    <br /><br />
                    For more info, you can give us a call on
                    <br/>
                    <b class="red">0860 50 50 50</b></p>`;

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {},
                cancelButtonText: 'Exit quote'
            }
        });
    }
}

export const showModalServiceHistory = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">Unfortunately, we don't offer car warranty insurance for cars that don't have a full service history from an accredited provider.
                    <br /><br />
                    Please take your car to a manufacturer-approved or RMI-registered service centre to have this done so you can get car warranty with us.
                    <br /><br />
                    For more info, you can give us a call on
                    <br/>
                    <b class="red">0860 50 50 50</b></p >`;

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {},
                cancelButtonText: 'Exit quote'
            }
        });
    }
}

export const showModalWarrantyInsurance = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">If you're covered for the same amount at another insurance company (this is called dual insurance) then we'll only be liable for a portion of your claim.
                    <br /><br />
                    For more info, you can give us a call on
                    <br/>
                    <b class="red">0860 50 50 50</b></p >`;

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {},
                okButtonStyle: 'w-100 btn btn-solid-green'
            }
        });
    }
}

export const showModalKiloCheck = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">Unfortunately, we don't offer car warranty insurance for cars that have more than 200,000kms on the clock.
                    <br /><br />
                    For more info, you can give us a call on
                    <br/>
                    <b class="red">0860 50 50 50</b></p>`;

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {},
                cancelButtonText: 'Exit quote'
            }
        });
    }
}

export const showModalAddBuildingCover = () => {
    return (dispatch, getState) => {
        let body = "";
        let footer = ``
        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './Images/OnlineQuotation/BuildingAndHomeContent/building-&-home-house-icon.svg',
                titleText: 'Would you like to add cover for your building',
                body: body,
                footer: footer,
                buttons: [
                    { text: 'Yes', event: () => { dispatch(showModalBuildingSameAddress()) }, className: 'btn btn-solid-red w-100' },
                    {
                        text: 'No', event: () => {
                            dispatch(setIsOnQuoteScreen(false, "", ""));
                            dispatch(navigateTo(BANKING_DETAILS))
                        }, className: 'btn btn-outline-red w-100'
                    }
                ],
            }
        });
    }
}

export const showModalAddHomeContentsCover = () => {
    return (dispatch, getState) => {
        let body = "";
        let footer = "";

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './Images/OnlineQuotation/BuildingAndHomeContent/building-&-home-content-fridge-&-tv.svg',
                titleText: 'Would you like to add cover for your home contents',
                body: body,
                footer: footer,
                buttons: [
                    { text: 'Yes', event: () => { dispatch(showModalAddHomeContentsSameAddress()) } , className: 'btn btn-solid-red w-100' },
                    {
                        text: 'No', event: () => {
                            dispatch(setIsOnQuoteScreen(false, "", ""));
                            dispatch(navigateTo(BANKING_DETAILS));
                        }, className: 'btn btn-outline-red w-100'
                    }
                ],
            }
        });
    }
}

export const showModalAddHomeContentsSameAddress = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma pl-1 pr-1">By adding cover for your home contents you're confirming that the address you'd like to be covered at is the same as the address linked to your buildings insurance.
                <br/><br/>
                If you'd like buildings insurance cover for a different address, please click on <b>'get a quote'</b>.</p>`;

        let footer = `<b>Alternatively you can WhatsApp us on</b> 
                <br/>
                <b class="red">0860 50 50 50</b>
                <br/>
                <b>or email <a class="red" href="mailto:clientcare@kingprice.co.za" target="_blank">clientcare@kingprice.co.za</a></b>
                `;

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Important',
                body: body,
                footer: footer,
                buttons: [
                    { text: 'Confirm', event: () => { dispatch(switchToHomeContent()) }, className: 'btn btn-solid-green w-100 pb-3 pt-3 mb-3' },
                    { text: 'Get a quote', event: () => { dispatch(navigateTo(GET_HOME_CONTENT_QUOTATION)) }, className: 'btn btn-outline-black w-100 pb-3 pt-3 mb-2' }
                ],
            }
        });
    }
}

export const showModalBuildingSameAddress = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma pl-1 pr-1">By adding cover for your building you're confirming that the address you'd like to be covered at is the same as the address linked to your home contents insurance.
                    <br/><br/>
                    If you'd like buildings insurance cover for a different address, please click on <b>'get a quote'</b>.</p>`;

        let footer = `<b>Alternatively you can WhatsApp us on</b> 
                    <br/>
                    <b class="red">0860 50 50 50</b>
                    <br/>
                    <b>or email <a class="red" href="mailto:clientcare@kingprice.co.za" target="_blank">clientcare@kingprice.co.za</a></b>
                    `;

        dispatch({
            type: MODAL_SALES_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Important',
                body: body,
                footer: footer,
                buttons: [
                    { text: 'Confirm', event: () => { dispatch(switchToBuilding()) }, className: 'btn btn-solid-green w-100 pb-3 pt-3 mb-3' },
                    { text: 'Get a quote', event: () => { dispatch(navigateTo(GET_BUILDING_QUOTATION)) }, className: 'btn btn-outline-black w-100 pb-3 pt-3 mb-2' }
                ],
            }
        });
    }
}
